import React, { useCallback, useEffect, useState } from "react";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import Logo from "../assets/Logo.png";
import StarIcon from "../assets/StartIcon.png";
import moment from "moment";
import { CurrentCaaqmsData, dataType } from "./type";
import { AQIDataItem } from "../utils/types";
import { MarkerView } from "../components/MarkerView";
import { v4 as uuidv4 } from "uuid";
import AQITable from "../components/AIrQualityValueTable";

const Page1 = ({
  AQIInfo,
  AQIColor,
  currentTempData,
  isLoaded,
  aqiData,
}: {
  isLoaded: boolean;
  AQIColor: any;
  AQIInfo: dataType | undefined;
  currentTempData: CurrentCaaqmsData | undefined;
  aqiData: AQIDataItem[];
}) => {
  console.log(currentTempData);
  const [map, setMap] = useState<any>(null);

  const onLoad = useCallback((map: any) => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const containerStyle: React.CSSProperties = {
    width: "100%",
    height: "100%",
  };

  const center = {
    lat: 22.9868, // West Bengal coordinates
    lng: 87.855,
  };

  // const options = {
  //   mapTypeControl: true,
  //   mapTypeControlOptions: {
  //     position: window.google.maps.ControlPosition.BOTTOM_LEFT, // Move to bottom center
  //     style: window.google.maps.MapTypeControlStyle.HORIZONTAL_BAR,
  //   },
  // };

  // const hours = new Date().getHours();
  // const [time, setTime] = useState<string>("");
  // const [isDayTime, setIsDayTime] = useState(hours > 6 && hours < 20);

  // useEffect(() => {
  //   // Update the time every second
  //   const intervalId = setInterval(() => {
  //     setIsDayTime(hours > 6 && hours < 20);
  //     setTime(moment().format("hh:mm A"));
  //   }, 1000);

  //   // Clean up the interval on component unmount
  //   return () => clearInterval(intervalId);
  // }, []);
  return (
    <div className="flex justify-center items-center w-screen h-screen  bg-[#181818]">
      <div className="w-full h-full bg-[#181818] flex flex-col items-center overflow-hidden">
        {/* Header bg-[#181818] */}

        <div className="w-full h-full">
          {isLoaded ? (
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={8}
              onLoad={onLoad}
              onUnmount={onUnmount}
              // options={options}
            >
              <div className="flex items-center justify-center absolute top-0 bg-white w-full text-center py-2 gap-1">
                <img src={Logo} className="w-12 h-12 " />
                <div className="">
                  <h1 className=" text-[#10A8FF] font-bold text-[1.5rem]">
                    WBPCB AIR QUALITY MONITORING SYSTEM
                  </h1>
                </div>
              </div>

              <div className="absolute bottom-6 left-2 bg-white p-2 shadow-lg z-50 rounded-md">
                <div className="flex items-center mb-2">
                  <div className="w-6 h-6  bg-purple-800 border mr-2" />
                  <p className="font-bold text-gray-800 text-lg">Analyzer</p>
                </div>
                <div className="flex items-center">
                  <div className="w-6 h-6 bg-pink-300 border mr-2" />
                  <p className="font-bold text-gray-800 text-lg">Sensor</p>
                </div>
              </div>
              <div className="absolute bottom-28 left-2 shadow-lg z-50">
                <AQITable />
              </div>

              {aqiData?.map((data, index) => {
                return (
                  <MarkerView
                    key={uuidv4()}
                    data={data}
                    index={index}
                    // noAnimation={noAnimation}
                  />
                );
              })}
            </GoogleMap>
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Page1;
